import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import "./SignUp.css";
import { gettoastsuccess, gettoastwarning, handleFirebaseError } from "../../Utils/Common";
import API from '../../Utils/Api';
import { validateForm } from "../../Utils/validate";
import { auth, googleProvider } from "../../Utils/firebase";
import { RecaptchaVerifier, signInWithPhoneNumber, signInWithPopup } from "firebase/auth";
import CustomLoader from "../../components/CustomLoader";
import { useAuth } from "../../hooks/useAuth";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";


const SignUp = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showValidations, setShowValidations] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  // const [inputs, setInputs] = useState({ first_name: 'Test', last_name: 'Demo', email: 'aaa@email.com', country_code: '+353', mobile_number: '123456787', full_mobile_number: '+353123456787', gender: 'Male', password: 'Abc@1234', confirm_password: 'Abc@1234', accept_terms: true }); // TEST
  const [inputs, setInputs] = useState({ first_name: '', last_name: '', email: '', country_code: '+353', mobile_number: '', full_mobile_number: '', gender: '', password: '', confirm_password: '', accept_terms: false,day:'',month:'',year:'' });
  // Validations
  const validations = {
    length: inputs.password.length >= 8,
    number: /\d/.test(inputs.password),
    upperLower: /[a-z]/.test(inputs.password) && /[A-Z]/.test(inputs.password),
    specialChar: /[^A-Za-z0-9]/.test(inputs.password)
  };


  useEffect(() => {
    document.title = `SignUp | Your Friend My Friend`;
    document.getElementById('bodywrap').className = 'brand';
  }, []);

  // Helper: choose correct image
  const getIcon = (isValid) => process.env.REACT_APP_BASE_URL + (isValid ? "assests/images/icon_valid.png" : "assests/images/icon_invalid.png");
  const handleInputChange = (event) => {
    setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
  }

 const handleInputChangePass = (event) => {
    setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
    if (!showValidations) setShowValidations(true);
  } 
  const handleInputChangeCustom = (field, value) => {
    setInputs({ ...inputs, [field]: value })
  }
  /* ---- Send OTP ---- */
  const setupRecaptcha = () => {

    // avoid re-creating verifier multiple times
    window.recaptchaVerifier = new RecaptchaVerifier(
      auth,
      "recaptcha-container",
      {
        size: "invisible",
        callback: () => console.log("reCAPTCHA verified"),
      }
    );
  };

  const sendOtp = async () => {
    setLoading(true);
    try {
      setupRecaptcha();
      const appVerifier = window.recaptchaVerifier;
      const phoneNumber = inputs.country_code + inputs.mobile_number
      const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
      const verificationId = confirmationResult.verificationId;
      setLoading(false);
      gettoastsuccess('OTP sent!', '', 1000);
      setTimeout(() => {
        navigate("/otp/", { state: { ...inputs, verificationId, origin: 'signup' } });
      }, 1000);
    } catch (error) {
      setLoading(false);
      console.log("SMS not sent", error?.message);
      handleFirebaseError(error)
    }
  };
  /* ---- Sign up ---- */
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log('inputs.accept_terms', inputs.accept_terms);

    const fields = [
      { field: 'first_name', label: 'First Name', rules: 'required', value: inputs.first_name },
      { field: 'last_name', label: 'Last Name', rules: 'required', value: inputs.last_name },
      { field: 'email', label: 'Email Address', rules: 'required|valid_email', value: inputs.email },
      { field: 'mobile_number', label: 'Phone Number', rules: 'required|number', value: inputs.mobile_number },
      { field: 'password', label: 'Password', rules: 'required|strong_password', value: inputs.password },
      { field: 'confirm_password', label: 'Confirm Password', rules: 'required|matches:password', value: inputs.confirm_password },
      { field: 'accept_terms', label: 'Agreement', rules: 'required', value: inputs.accept_terms ? '1' : '' },
    ];
    console.log('fields', fields);
    const errors = validateForm(fields);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);

    } else {
      setErrors({});
      doSignUp();
    }
  }
  const doSignUp = async () => {
    setLoading(true);
    let error;
    try {
      const formInputs = { ...inputs, mobile_number: inputs.mobile_number, is_submit: 0 }
      console.log('signup inputs', formInputs);
      API.post('register_masterclass', formInputs)
        .then(response => {
          setLoading(false);
          console.log('signup response', response.data);
          if (response.data.status === false) {
            gettoastwarning(response.data.message);
          } else {
            // Send OTP
            sendOtp();
          }
        }).catch(e => {
          error = e.message;
          gettoastwarning(error);
        });
    } catch (e) {
      setLoading(false);
      error = e.message;
      gettoastwarning(error);
    }
  };
  /* Social Login */
  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const socialUserData = result.user;
      const socialUserTokenRes = result._tokenResponse;
      
      const email = socialUserData?.email;
      // const provider_id = socialUserData.uid; 
      
      // console.log('signed in user', result);
      const userData = { type: 'google', first_name: socialUserTokenRes?.firstName, last_name: socialUserTokenRes?.lastName, email, social_token: socialUserData?.providerData?.[0]?.uid }
      console.log('userData',userData);
      
      doSocialLogin(userData);

    } catch (error) {
      console.error("Google Sign-In Error:", error);
      gettoastwarning("Google login failed. Please try again later.");
    }
  };
  const handleFacebookLogin = (res) => {
  //console.log(res);
    try {
      
      const userData = { type: 'facebook', first_name: res?.first_name, last_name: res?.last_name, email:res?.email, social_token: res?.id }
      console.log('userData',userData);
      
      doSocialLogin(userData);

    } catch (error) {
      console.error("Facebook Sign-In Error:", error);
      gettoastwarning("Facebook login failed. Please try again later.");
    }
  };
  const doSocialLogin = async (user_data) => {
    setLoading(true);
    let error;
    try {
      const formInputs = { ...user_data }
      console.log('login_with_social inputs', formInputs);
      API.post('login_with_social', formInputs)
        .then(response => {
          setLoading(false);
          const apiResponse = response.data;
          console.log('login_with_social response', response.data);
          if (response.data.status === false) {
            gettoastwarning(response.data.message);
          } else {
            if(localStorage.getItem('prev_page'))
            {
              gettoastsuccess(response.data.message, localStorage.getItem('prev_page'), 1000);
            }else{
              gettoastsuccess(response.data.message, '/dating-masterclass', 1000);
            }
            login(apiResponse?.data?.token)
          }
        }).catch(e => {
          error = e.message;
          gettoastwarning(error);
        });
    } catch (e) {
      setLoading(false);
      error = e.message;
      gettoastwarning(error);
    }
  };
  

  return (
    <>
      <CustomLoader loading={loading} />
      <div className="container-fluid d-flex align-items-center justify-content-center min-vh-100 lo-oma">
        <div className="row w-100 my-5">
          <div className="col-md-6 col-lg-4 mx-auto">
            <div className="p-2">
              <h3 className="text-center mb-4">Welcome!</h3>
              <form method="post" onSubmit={handleSubmit} encType="multipart/form-data" >
                <div className="mb-3">
                  <div className={`input-group ${errors.first_name ? 'form-error' : ''}`}>
                    <span className="input-group-text">
                      <img
                        src={process.env.REACT_APP_BASE_URL + "assests/images/icon_user.png"}
                        alt="men"
                        className="img-fluid input-icon"
                      />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="First Name"
                      name="first_name"
                      value={inputs.first_name}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.first_name && (
                    <p className="text-danger error-text">{errors.first_name}</p>
                  )}
                </div>
                <div className="mb-3">
                  <div className={`input-group ${errors.last_name ? 'form-error' : ''}`}>
                    <span className="input-group-text">
                      <img
                        src={process.env.REACT_APP_BASE_URL + "assests/images/icon_user.png"}
                        alt="men"
                        className="img-fluid input-icon"
                      />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last Name"
                      name="last_name"
                      value={inputs.last_name}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.last_name && (
                    <p className="text-danger error-text">{errors.last_name}</p>
                  )}
                </div>
                <div className="mb-3">
                  <div className={`input-group ${errors.email ? 'form-error' : ''}`}>
                    <span className="input-group-text">
                      <img
                        src={process.env.REACT_APP_BASE_URL + "assests/images/icon_email.png"}
                        alt="email"
                        className="img-fluid input-icon"
                      />
                    </span>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email address"
                      name="email"
                      value={inputs.email}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.email && (
                    <p className="text-danger error-text">{errors.email}</p>
                  )}
                </div>
                <div className="mb-3">
                  <PhoneInput
                    country={"ie"}
                    placeholder="Phone number"
                    inputProps={{
                      name: "full_mobile_number",
                      required: true,
                      autoFocus: false,
                    }}
                    inputStyle={{ width: "100%" }}
                    value={inputs.full_mobile_number}
                    containerClass={`${errors.mobile_number && 'form-error'}`}
                    onChange={(value, countryData = {}, event) => {
                      const dialCode = countryData.dialCode || '';
                      // Remove dial code from the value (with '+' just to be safe)
                      let numberWithoutCode = value;
                      if (dialCode) {
                        const cleanDial = `+${dialCode}`;
                        if (value.startsWith(cleanDial)) {
                          numberWithoutCode = value.slice(cleanDial.length);
                        } else if (value.startsWith(dialCode)) {
                          numberWithoutCode = value.slice(dialCode.length);
                        }
                      }
                      setInputs({ ...inputs, country_code: `+${dialCode}`, mobile_number: numberWithoutCode, full_mobile_number: `+${dialCode}${numberWithoutCode}` })
                    }}
                  />
                  {errors.mobile_number && (
                    <p className="text-danger error-text">{errors.mobile_number}</p>
                  )}
                </div>
                {/* Password */}
                <div className="mb-3">
                  <div className={`input-group ${errors.password ? 'form-error' : ''}`}>
                    <span className="input-group-text">
                      <img
                        src={process.env.REACT_APP_BASE_URL + "assests/images/icon_password.png"}
                        alt="password"
                        className="img-fluid input-icon"
                      />
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Password"
                      name="password"
                      value={inputs.password}
                      onChange={handleInputChangePass}
                     
                    />
                    <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}>
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          (showPassword
                            ? "assests/images/icon_eye.png"
                            : "assests/images/icon_eye_slash.png")
                        }
                        alt="toggle-visibility"
                        className="img-fluid input-icon"
                      />
                    </span>
                  </div>
                  {errors.password && (
                    <p className="text-danger error-text">{errors.password}</p>
                  )}
                  {showValidations && (
                    <div className="mt-2">
                      <div className="condtions-or d-flex align-items-start gap-2 mb-1 mt-1">
                        <img src={getIcon(validations.length)} alt="condition" className="img-fluid validation-icon" />
                        At least 8 characters
                      </div>
                      <div className="condtions-or d-flex align-items-start gap-2 mb-1">
                        <img src={getIcon(validations.number)} alt="condition" className="img-fluid validation-icon" />
                        At least 1 number
                      </div>
                      <div className="condtions-or d-flex align-items-start gap-2 mb-1">
                        <img src={getIcon(validations.specialChar)} alt="condition" className="img-fluid validation-icon" />
                        At least 1 special character
                      </div>
                      <div className="condtions-or d-flex align-items-start gap-2">
                        <img src={getIcon(validations.upperLower)} alt="condition" className="img-fluid validation-icon" />
                        Both upper and lower case letters
                      </div>
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <div className={`input-group ${errors.confirm_password ? 'form-error' : ''}`}>
                    <span className="input-group-text">
                      <img
                        src={process.env.REACT_APP_BASE_URL + "assests/images/icon_password.png"}
                        alt="password"
                        className="img-fluid input-icon"
                      />
                    </span>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Confirm Password"
                      value={inputs.confirm_password}
                      name="confirm_password"
                      onChange={handleInputChange}
                    />
                    <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          (showConfirmPassword
                            ? "assests/images/icon_eye.png"
                            : "assests/images/icon_eye_slash.png")
                        }
                        alt="toggle-visibility"
                        className="img-fluid input-icon"
                      />
                    </span>
                  </div>
                  {errors.confirm_password && (
                    <p className="text-danger error-text">{errors.confirm_password}</p>
                  )}
                </div>
                <label className="form-label me-2">
                  Gender 
                </label>
                <div className="mb-3">
                  <div className="d-flex align-items-center gap-3 w-100">
                    <div className="d-flex gap-2 w-100 foker">
                      <label className="gender-option d-flex align-items-center">
                        <input
                          type="radio"
                          name="gender"
                          value="Male"
                          style={{ accentColor: "#1B2337", width: "18px", height: "18px" }}
                          onChange={handleInputChange}
                          checked={inputs.gender === 'Male'}
                        />
                        Male
                      </label>
                      <label className="gender-option d-flex align-items-center">
                        <input
                          type="radio"
                          name="gender"
                          value="Female"
                          style={{ accentColor: "#1B2337", width: "18px", height: "18px" }}
                          onChange={handleInputChange}
                          checked={inputs.gender === 'Female'}
                        />
                        Female
                      </label>
                      <label className="gender-option d-flex align-items-center">
                        <input
                          type="radio"
                          name="gender"
                          value="Non-binary"
                          style={{ accentColor: "#1B2337", width: "18px", height: "18px" }}
                          onChange={handleInputChange}
                          checked={inputs.gender === 'Non-binary'}
                        />
                        Non-binary
                      </label>
                    </div>
                  </div>
                  {errors.gender && (
                    <p className="text-danger error-text">{errors.gender}</p>
                  )}
                </div>
                <div className="mb-3">
                    <label className="form-label me-2">
                        Birthday 
                    </label>
                    <div className="row">
                        <div className="col-4">
                              <select name="day" id="day" className="form-control border-0" value={inputs.day} onChange={handleInputChange}>
                                  <option value="">Select Day </option>
                                  {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                    <option value={day}>
                                      {day}
                                    </option>
                                  ))}
                              </select>
                        </div>
                        <div className="col-4">
                              <select name="month" id="month" className="form-control border-0" value={inputs.month} onChange={handleInputChange}>
                                  <option value="">Select Month </option>
                                  {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                    <option value={month}>
                                      {month}
                                    </option>
                                  ))}
                              </select>
                        </div>
                        <div className="col-4">
                              <select name="year" id="year" className="form-control border-0" value={inputs.year} onChange={handleInputChange}>
                                  <option value="">Select Year </option>
                                  {Array.from(
                                    { length: (new Date().getFullYear() - 19) - 1940 + 1 },
                                    (_, i) => 1940 + i
                                  ).map((year) => (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  ))}
                              </select>
                        </div>
                    </div>
                </div>
                <div className="form-check mb-3 d-flex align-items-start sign-ghar">
                  <input
                    type="checkbox"
                    className={`form-check-input ${errors.accept_terms && 'form-error'}`}
                    id="subscribe"
                    name="accept_terms"
                    value={inputs.accept_terms ? '1' : ''}
                    checked={inputs.accept_terms}
                    onChange={(event) => handleInputChangeCustom('accept_terms', event.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="accept_terms">
                    By Signing up, you agree to our <span className="undu-linung"><Link to="" className="text-decoration-none">Terms and Conditions,</Link> <Link to="#" className="text-decoration-none">Privacy Policy</Link> and <Link to="#" className="text-decoration-none">Community Guidelines</Link></span>
                  </label>
                </div>
                {errors.accept_terms && (
                  <p className="text-danger error-text">{errors.accept_terms}</p>
                )}
                {/* Login button */}
                <div className="d-grid mb-3 mt-3 text-center">
                  <button className="logus-in" type="submit">
                    Sign up
                  </button>
                </div>
              </form>
              {/* OR divider */}
              <div className="text-center my-3 mt-5 divider">
                <span className="oru">Or</span>
                <hr />
              </div>
              {/* Social buttons */}
              <div className="d-grid gap-3 mb-4">
                {/*<Link to="" className="d-flex align-items-center justify-content-center face-bor" onClick={handleFacebookLogin}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + "assests/images/icon_facebook.png"}
                    alt="facebook"
                    className="img-fluid input-icon"
                  /> Sign up with Facebook
                </Link>*/}
                <FacebookLogin
                appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                autoLoad={false}
                fields="id,name,email,first_name,last_name,picture"
                callback={handleFacebookLogin}
                render={(renderProps) => (
                <Link to="" className="d-flex align-items-center justify-content-center face-bor" onClick={renderProps.onClick}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + "assests/images/icon_facebook.png"}
                    alt="facebook"
                    className="img-fluid input-icon"
                  /> Sign up with Facebook
                </Link>
                )}
              />
                <Link to="" className="d-flex align-items-center justify-content-center face-bor" onClick={handleGoogleLogin}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + "assests/images/icon_google.png"}
                    alt="google"
                    className="img-fluid input-icon"
                  /> Sign up with Google
                </Link>
              </div>
              {/* Register */}
              <p className="text-center register-ola mb-0">
                Already have an account?{" "}
                <Link to="/login">
                  Log in
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="recaptcha-container"></div>
    </>
  );
};
export default SignUp;
